import { forwardRef } from "react";
import PropTypes from "prop-types";
import { NumericFormat } from "react-number-format";
import MKInputRoot from "../MKInputRoot";

const MKNumberInput = forwardRef(({
  error,
  disabled,
  decimalScale,
  onRawValueChange,
  allowLeadingZeros,
  thousandSeparator = " ",
  ...rest
}, ref) => {

  return (
    <NumericFormat
      {...rest}
      getInputRef={ref}
      customInput={MKInputRoot}
      thousandSeparator={thousandSeparator}
      decimalSeparator="."
      decimalScale={decimalScale}
      fixedDecimalScale
      allowNegative={false}
      allowLeadingZeros={allowLeadingZeros}
      onValueChange={({ formattedValue }) => onRawValueChange(formattedValue)} 
      ownerState={{ error, disabled }}
    />
  );
})


MKNumberInput.defaultProps = {
  error: false,
  disabled: false,
  decimalScale: 0,
  onRawValueChange: () => { },
  allowLeadingZeros: false,
};

// Typechecking props for the MKNumberInput
MKNumberInput.propTypes = {
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  decimalScale: PropTypes.number,
  onRawValueChange: PropTypes.func,
  allowLeadingZeros: PropTypes.bool,
  thousandSeparator: PropTypes.string,
};

export default MKNumberInput;
